<!-- DO NOT USE ASYNC HERE -->
@if (scope$ | async) {
  <router-outlet></router-outlet>
}
